import moment from "moment";

export const parseQueryParams = (search: string): Record<string, string> => {
  const queryParams = new URLSearchParams(search);
  const params: Record<string, string> = {};

  queryParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export const checkAcessRights = (route: string, rightID: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  return userResponse
    ?.find((e: any) => e.MenuKey === route?.substring(1))
    ?.RightsID?.includes(rightID);
};

export const hasRights = (menuKey: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const menu = userResponse.find((item) => item.MenuKey === menuKey);
  return menu && menu.RightsID;
};

export const getFilterFromToDate = (SelectedDate: number) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() - today.getDay());
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() - 30);
  const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

  const formate = (date: Date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  switch (SelectedDate) {
    case 1:
      return { FromDate: formate(today), ToDate: formate(today) };
    case 2:
      return {
        FromDate: formate(yesterday),
        ToDate: formate(yesterday),
      };
    case 3:
      return {
        FromDate: formate(weekStart),
        ToDate: formate(today),
      };
    case 4:
      return {
        FromDate: formate(last30Days),
        ToDate: formate(today),
      };
    case 5:
      return {
        FromDate: formate(monthStart),
        ToDate: formate(today),
      };
    default:
      return {
        FromDate: "",
        ToDate: "",
      };
  }
};

export function formatIndianNumber(number: number, decimal: any = 2): string {
  if (number === null || number === undefined) return "";
  let [integerPart, decimalPart] = number.toFixed(decimal).split(".");
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return formattedOtherDigits + lastThreeDigits + "." + decimalPart;
}

export const getLocalStorageData = (item: string) => {
  return localStorage.getItem(item);
};

export function convertToIndianWords(number: any) {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  let words = "";
  if (number === 0) {
    return "Zero";
  }
  if (Math.floor(number / 10000000) > 0) {
    words += convertToIndianWords(Math.floor(number / 10000000)) + " Crore ";
    number %= 10000000;
  }
  if (Math.floor(number / 100000) > 0) {
    words += convertToIndianWords(Math.floor(number / 100000)) + " Lakh ";
    number %= 100000;
  }
  if (Math.floor(number / 1000) > 0) {
    words += convertToIndianWords(Math.floor(number / 1000)) + " Thousand ";
    number %= 1000;
  }
  if (Math.floor(number / 100) > 0) {
    words += convertToIndianWords(Math.floor(number / 100)) + " Hundred ";
    number %= 100;
  }
  if (number > 0) {
    if (words !== "") {
      words += "and ";
    }
    if (number < 10) {
      words += ones[number];
    } else if (number < 20) {
      words += teens[number - 10];
    } else {
      words += tens[Math.floor(number / 10)];
      if (number % 10 > 0) {
        words += " " + ones[number % 10];
      }
    }
  }
  return words;
}

export function calculateDuration(
  departureDate: string,
  departureTime: string,
  arrivalDate: string,
  arrivalTime: string,
): string {
  const departure = new Date(`${departureDate}T${departureTime}`);
  const arrival = new Date(`${arrivalDate}T${arrivalTime}`);

  const diffMs = arrival.getTime() - departure.getTime();

  if (diffMs < 0) {
    return "-";
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  let result = "";
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m`;

  return result.trim() || "0m";
}

export function generateValueLabelRange<T extends number | string>(
  start: number,
  end: number,
  as: "number" | "string",
): { value: T; label: T }[] {
  const result: { value: T; label: T }[] = [];

  for (let i = start; i <= end; i++) {
    const val = (as === "string" ? String(i) : i) as T;
    result.push({ value: val, label: val });
  }

  return result;
}

export const getLocalStorageItem = (Name: string) => {
  return localStorage.getItem(Name);
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w-]+/g, "") // Remove all non-word chars (fixed)
    .replace(/-+/g, "-") // Replace multiple - with single - (fixed)
    .replace(/^-+/, ""); // Trim - from start of text
  // .replace(/-+$/, ""); // Trim - from end of text
};

// Helper function to convert HTML to WhatsApp format
export const convertHtmlToWhatsAppFormat = (html: string): string => {
  if (!html) return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const processNode = (node: Node): string => {
    let result = "";

    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent || "";
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      const tagName = element.tagName.toLowerCase();

      const childrenContent = Array.from(element.childNodes)
        .map((child) => processNode(child))
        .join("");

      const trimmedContent = childrenContent.trim();

      switch (tagName) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          result = `\n*${trimmedContent}*\n`;
          break;

        case "strong":
        case "b":
          result = `*${trimmedContent}*`;
          break;

        case "em":
        case "i":
          result = `_${trimmedContent}_`;
          break;

        case "u":
          result = `*${trimmedContent}*`;
          break;

        case "p":
          // Use single newline for p to avoid "up & down" spacing
          result = trimmedContent ? `${trimmedContent}\n` : "";
          break;

        case "br":
          result = "\n";
          break;

        case "div":
          result = trimmedContent ? `${trimmedContent}\n` : "";
          break;

        case "ul":
        case "ol":
          result = `\n${childrenContent}\n`;
          break;

        case "li": {
          const parent = element.parentElement;
          if (parent?.tagName.toLowerCase() === "ol") {
            const index = Array.from(parent.children).indexOf(element) + 1;
            result = `${index}. ${trimmedContent}\n`;
          } else {
            result = `• ${trimmedContent}\n`;
          }
          break;
        }

        case "span":
          result = childrenContent;
          break;

        case "a": {
          const href = element.getAttribute("href");
          result = href ? `${trimmedContent} (${href})` : trimmedContent;
          break;
        }

        default:
          result = childrenContent;
      }
    }

    return result;
  };

  let whatsappText = "";
  Array.from(tempDiv.childNodes).forEach((node) => {
    whatsappText += processNode(node);
  });

  return whatsappText
    .replace(/\n{3,}/g, "\n\n") // Collapse triple newlines
    .split("\n")
    .map((line) => line.trim())
    .join("\n")
    .trim();
};

// Helper function to copy HTML to clipboard (for email)
export const copyHtmlToClipboard = async (html: string) => {
  // Ensure we have a complete HTML document for email
  if (!html.includes("<html")) {
    html = `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
</head>
<body>
    ${html}
</body>
</html>`;
  }

  const htmlBlob = new Blob([html], { type: "text/html" });
  const plainBlob = new Blob([extractPlainTextFromHtml(html)], {
    type: "text/plain",
  });

  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": htmlBlob,
      "text/plain": plainBlob,
    }),
  ]);
};

export const extractPlainTextFromHtml = (html: string): string => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};
